import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

const DEFINITIONS_COMPONENT = 'search-ai-definitions';

export const aiDefinitionsLoadUFOExperience: UFOExperience = new UFOExperience(`${DEFINITIONS_COMPONENT}-load`, {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	platform: { component: DEFINITIONS_COMPONENT },
});
